export const urkSubMenu = {
  export: { title: 'Експорт', link: '#' },
  forbusiness: 'Для бізнесу',
  foryou: 'Для тебе',
  import: { title: 'Імпорт', link: '#' },
  list: [
    { title: 'Особистий кабінет', link: '/login' },
    { title: 'Трекінг', link: '/track/' },
    { title: 'Продукти і сервіси', link: '/products-services' },
    { title: 'Шопінг', link: 'https://npshopping.com' },
    { title: 'Хто ми', link: '/about' },
    { title: "Кар'єра", link: '/career' },
    { title: 'Новини', link: '/news' },
    { title: 'Контакти', link: '/contact' },
  ],
  recieve: { title: 'Отримання', link: '#' },
  send: { title: 'Відправлення', link: '#' },
}

export const enSubMenu = {
  export: { title: 'Export', link: '#' },
  forbusiness: 'For business',
  foryou: 'For you',
  import: { title: 'Import', link: '#' },
  list: [
    { title: 'Personal account', link: '/login' },
    { title: 'Tracking', link: '/track/' },
    { title: 'Products and services', link: '/products-services' },
    { title: 'Shopping', link: 'https://npshopping.com' },
    { title: 'Who we are', link: '/about' },
    { title: 'Career', link: '/career' },
    { title: 'News', link: '/news' },
    { title: 'Contacts', link: '/contact' },
  ],
  recieve: { title: 'Receiving', link: '#' },
  send: { title: 'Sending', link: '#' },
}

export const ruSubMenu = {
  export: { title: 'Экспорт', link: '#' },
  forbusiness: 'Для бизнеса',
  foryou: 'Для тебя',
  import: { title: 'Импорт', link: '#' },
  list: [
    { title: 'Личный кабинет', link: '/login' },
    { title: 'Трекинг', link: '/track/' },
    { title: 'Продукты и сервисы', link: '/products-services' },
    { title: 'Шопинг', link: 'https://npshopping.com' },
    { title: 'Кто мы', link: '/about' },
    { title: 'Карьера', link: '/career' },
    { title: 'Новости', link: '/news' },
    { title: 'Контакты', link: '/contact' },
  ],
  recieve: { title: 'Получение', link: '#' },
  send: { title: 'Отправление', link: '#' },
}
